import {
  itemMatchesSearchQuery as matchByFields,
  textMatchesSearchQuery,
} from 'src/utils/itemMatchesSearchQuery';
import { formatFormManagementYmd } from './formManagementTableData';
import { getStatusDisplayText } from './formManagementStatusBadge';
import { FormData, FormStatusTab } from './types';

const SEARCHABLE_FIELDS: (keyof FormData)[] = [
  'title',
  'description',
  'category',
  'languages',
  'questionsCount',
  'countryCount',
  'createdBy',
];

function formStatusSearchText(status: FormStatusTab): string {
  return `${getStatusDisplayText(status)} ${status}`;
}

function formDateSearchText(iso: string): string {
  const raw = (iso ?? '').trim();
  if (!raw) return '';
  return formatFormManagementYmd(raw) || '';
}

function formDatesSearchBlob(form: FormData): string {
  return [
    formDateSearchText(form.createdAt),
    formDateSearchText(form.lastUpdated),
  ]
    .filter(Boolean)
    .join(' ');
}

export function formMatchesSearchQuery(form: FormData, query: string): boolean {
  if (matchByFields(form, query, SEARCHABLE_FIELDS)) return true;
  if (textMatchesSearchQuery(formStatusSearchText(form.status), query)) {
    return true;
  }
  return textMatchesSearchQuery(formDatesSearchBlob(form), query);
}
